// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailO":"O_d2xDetailO__zrDh_"};